export default "__VITE_ASSET__DlBapF86__";